import { Navigate } from "react-router-dom";
import { useAuth } from "../../utils/useAuth";

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, accessToken } = useAuth();

  if (!isLoggedIn && !accessToken) {
    return <Navigate to={"/authentication/signin"} replace />;
  }

  return children;
};

export default ProtectedRoute;
